import { api } from "./client";
import type { MeDto, SidebarEntryDto, DashboardDto } from "@/types/api";

export const authApi = {
  login: (email: string, password: string) =>
    api.post<MeDto>("/auth/login", { email, password }),
  logout: () => api.post<void>("/auth/logout"),
  me: () => api.get<MeDto>("/auth/me"),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post<void>("/auth/change-password", { currentPassword, newPassword }),
  // Staff welcome-email set-password flow (anonymous; token is the proof
  // of identity). validate is non-consuming; confirm burns the token.
  validateSetPasswordToken: (token: string) =>
    api.get<{ valid: boolean }>("/auth/set-password/validate", { token }),
  confirmSetPassword: (token: string, newPassword: string) =>
    api.post<void>("/auth/set-password/confirm", { token, newPassword }),
};

export const configApi = {
  sidebar: () => api.get<SidebarEntryDto[]>("/config/sidebar"),
};

export const dashboardApi = {
  /** `role` selects which recipe to assemble (only honored server-side when
   *  the caller holds that role; ADMIN may view any). It never widens data
   *  access — every widget is permission-gated on the caller's own claims. */
  get: (role?: string) => api.get<DashboardDto>("/dashboard", role ? { role } : undefined),
};
